import { gql } from '@apollo/client';
import appraiserEventFieldsFragment from './appraiserEventFragment';
import userEventParticipationInfoCalendarViewFragment from './userEventParticipationInfoCalendarViewFragment';

const GET_ATM_CALENDAR = gql`
  query GetATMCalendar($start: DateOnly!, $end: DateOnly!, $externalUserId: Int, $eventPhase: Int) {
    appraiserEvents(
      start: $start
      end: $end
      externalUserId: $externalUserId
      eventPhase: $eventPhase
    ) {
      ...AppraiserEventFields
      TargetUserEventParticipationInfo(targetUserId: $externalUserId) {
        ...UserEventParticipationInfoFields
      }
    }
    hasAppraiserEvents(externalUserId: $externalUserId, eventPhase: $eventPhase)
  }

  ${userEventParticipationInfoCalendarViewFragment}
  ${appraiserEventFieldsFragment}
`;

export default GET_ATM_CALENDAR;
